import React, { useState } from 'react'
import { Box, Button, Typography, IconButton, useTheme } from '@material-ui/core'
import FormUpdate from './FormUpdate'
import { ArrowBack } from '@material-ui/icons'
import { Link, useHistory } from 'react-router-dom'
import { useTranslate, useDataProvider, Loaing } from 'react-admin'
import ConfirmDialog from '../CustomizedUIs/confirmDialog';
import DeleteIcon from '../assets/icons/primary-blue-bin.png'
import GoBackButton from '../CustomizedUIs/GoBackButton'

const EditChannel = (props) => {
    const dataProvider = useDataProvider()
    const theme = useTheme();
    const [name, setName] = useState('');
    const history = useHistory()
    const translate = useTranslate();
    const [loading, setLoading] = useState(false)
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false)

    const handleDelete = () => {
        dataProvider('DELETE', 'medias', {
            id: parseInt(props.match.params.id)
        }).then(response => {
            setOpenConfirmDialog(false)
            //setDeleted(clusterData)
            //handleClose()
            history.push({
                pathname: '/media',
                state: { open: true, name: name, message: translate(`pos.categories.deleteFolder.success`) }
            });

        }).catch(error => {
            // setError(translate(`resoures.room.deleteFailed`))
            // handleCloseConfirmDialog()
        })
    }

    return (
        <Box width='80%' m='auto'>
            <Box >

                <Box my={5} width={300} display='flex' component={Link} to={'/Media'} style={{ textDecoration: 'none' }}>
                    <Box display='flex' mr={2}>
                       <GoBackButton/>
                    </Box>
                    <Typography variant="subtitle1" color="primary" style={{ margin: 'auto 0', fontWeight: 'bold' }}>{translate(`pos.media.back`)}</Typography>
                </Box>
            </Box>
            <Box display='flex' justifyContent='center'>
                <Box width={500}>
                    {!loading &&
                        <Box display='flex' justifyContent='space-between'>
                            <Typography style={{ fontFamily: 'UniviaPro-Medium', fontWeight: 'normal', color: '#4f5064' }} variant='h5'>{translate(`pos.channels.editting`) + name}</Typography>
                            <Button size='small' onClick={() => setOpenConfirmDialog(true)}>
                                <img style={{ marginRight: '8px' }} src={DeleteIcon} width='18px' height='18px'></img>
                                <Typography style={{ marginRight: '16px' }} className={{
                                    fontFamily: 'UniviaPro',
                                    fontSize: '13px',
                                    fontWeight: 'normal',
                                    fontStretch: 'normal',
                                    fontStyle: 'normal',
                                    lineHeight: 1.385,
                                    letterSpacing: '0.13px',
                                    color: '#4f5064',
                                }}>{translate(`pos.media.delete`)}</Typography>
                            </Button>
                        </Box>
                    }
                    <Box>
                        <FormUpdate loading={loading} setLoading={setLoading} setName={setName} mediaId={parseInt(props.match.params.id)} />
                    </Box>
                </Box>
            </Box>
            <ConfirmDialog
                open={openConfirmDialog}
                handleClose={() => setOpenConfirmDialog(false)}
                handleConfirm={handleDelete}
                ContentText={translate(`pos.movie.confirmDelete`)}
                Tittle={translate(`pos.movie.delete`)} />
        </Box>
    )
}
export default EditChannel